"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
/**
 * Implementation of the external UI namespace.
 */
class UI extends api_shared_js_1.EventListenerManager {
    constructor(_impl) {
        super();
        this._impl = _impl;
        // Initialize our event handling for this class
        this._impl.initializeEvents().forEach((e) => this.addNewEventType(e));
    }
    displayDialogAsync(url, payload, options) {
        return this._impl.displayDialogAsync(url, payload, options);
    }
    sendDialogMessageAsync(message, targetDialogUrl) {
        return this._impl.sendDialogMessageAsync(message, targetDialogUrl);
    }
    sendDialogMessageToParentAsync(message) {
        return this._impl.sendDialogMessageToParentAsync(message);
    }
    closeDialog(payload, dialogUrl) {
        this._impl.closeDialog(payload, dialogUrl);
    }
}
exports.UI = UI;
//# sourceMappingURL=UI.js.map